module.exports = __webpack_public_path__ + "img/setting_26.8f98992d.svg";